import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'orderByTranslate',
  pure: false
})
export class OrderByTranslatePipe implements PipeTransform {

  constructor(private translateService: TranslateService) {
  }
  transform(items: any[], parentTranslation: string, customProperty?: string, isUpperCase: boolean = false, orderByProperty: boolean = false): any {
    if (!items) {
      return items;
    }

    if (items && items.length > 0 && items[0].type && items[0].type.toLowerCase() === 'parametricentities') {
      return items;
    }

    if (orderByProperty) {
      const elementTranslation = _.map(items, (newItem) => {
        const newItemWithTranslation = { ...newItem };
        let messageInput = '';
        if (newItem[customProperty].includes(parentTranslation))
          messageInput = parentTranslation + isUpperCase ? newItem[customProperty].toUpperCase() : newItem[customProperty];
        else
          messageInput = isUpperCase ? newItem[customProperty].toUpperCase() : newItem[customProperty];

        this.translateService.get(messageInput)
          .subscribe((res) => {
            newItemWithTranslation.translation = res;
          });
        return newItemWithTranslation;
      });
      const elementsSort = _.orderBy(elementTranslation, [(element) => element.translation.toLowerCase()]);
      return elementsSort;
    }

    return _.orderBy(_.map(items, (newItem) => {
      const newItemWithTranslation = { ...newItem };
      this.translateService.get(parentTranslation +
        (newItem.key || newItem.name || (isUpperCase ? newItem[customProperty].toUpperCase() : newItem[customProperty])))
        .subscribe((res) => {
          newItemWithTranslation.translation = res;
        });
      return newItemWithTranslation;
    }), ['translation']);
  }
}
